// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ut-z","tooltipWrapper":"vt-z","icon":"wt-z","tooltip":"xt-z","content":"yt-z"};